import { render, staticRenderFns } from "./CustomerDeleteButton.vue?vue&type=template&id=3b169c90&scoped=true&"
import script from "./CustomerDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./CustomerDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDeleteButton.vue?vue&type=style&index=0&id=3b169c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b169c90",
  null
  
)

export default component.exports